<table>
  <thead>
    <tr>
      <th class="col-ref">{{ "LABELS.REF_N" | translate }}</th>
      <th class="col-company">{{ "LABELS.COMPANY" | translate }}</th>
      <th class="col-duties">{{ "LABELS.DUTIES" | translate }}</th>
      <th class="col-bl">{{ "LABELS.BL" | translate }}</th>
      <th class="col-state">{{ "LABELS.STATE" | translate }}</th>
      <th class="col-payment-state">{{ "LABELS.PAYMENT_STATE" | translate }}</th>
      <th class="col-status">{{ "LABELS.STATUS" | translate }}</th>
      <th class="col-date">{{ "LABELS.CREATED" | translate }}</th>
      <th class="col-delivery">{{ "LABELS.DELIVERY" | translate }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="totalRows === 0">
      <td colspan="9">
        <div>
          {{ "LABELS.EMPTY_LIST" | translate }}
        </div>
      </td>
    </tr>
    <tr *ngFor="let es of esList | async | paginate : { id: tableId, itemsPerPage: limit, currentPage: page, totalItems: total }">
      <td class="col-ref col-mobile-label" [attr.data-label]="'LABELS.REF_N' | translate" [title]="es.referenceNumber">
        <a [routerLink]="['/entry-summaries-management', es.id]">{{ es.referenceNumber }}</a>
      </td>
      <td class="col-company col-mobile-label" [attr.data-label]="'LABELS.COMPANY' | translate" [title]="es?.company?.name">
        <ng-template [ngIf]="showCompanyLink && es?.company">
          <a [routerLink]="['/companies-management', es.company.id]">
            {{ es.company.name }}
          </a>
        </ng-template>
        <ng-template [ngIf]="!showCompanyLink && es.company">
          <span>
            {{ es.company.name }}
          </span>
        </ng-template>
      </td>
      <td class="col-duties col-mobile-label" [attr.data-label]="'LABELS.DUTIES' | translate" [title]="es.estimatedDuties">
        {{ es.estimatedDuties }}
      </td>
      <td class="col-bl col-mobile-label" [attr.data-label]="'LABELS.BL' | translate" [title]="es.shipmentsCount">
        {{ es.shipmentsCount }}
      </td>
      <td class="col-state col-mobile-label" [attr.data-label]="'LABELS.STATE' | translate" [title]="es?.state">
        <div *ngIf="es?.state !== null && es?.state !== undefined">
          {{ ("STATUS_ES." + enumEntrySummaryState[es.state] | translate) + " (" + es.state + ")" }}
        </div>
      </td>
      <td class="col-payment-state col-mobile-label" [attr.data-label]="'LABELS.PAYMENT_STATE' | translate" [title]="es?.paymentState">
        <bill-status [showValue]="true" [billStatus]="es.paymentState"></bill-status>
      </td>
      <td class="col-status">
        <div class="d-flex">
          <es-status
            [submissionType]="es.submissionType"
            [state]="es.state"
            [paymentState]="es.paymentState"
            [showSecondTextForDeleted]="true"
            [customState]="es?.customState"
          ></es-status>
        </div>
      </td>
      <td class="col-date col-mobile-label" [attr.data-label]="'LABELS.CREATED' | translate" [title]="es.createdDate | customDateTimeByUtc">
        {{ es.createdDate | customDateTimeByUtc }}
      </td>
      <td
        class="col-delivery col-mobile-label"
        [attr.data-label]="'LABELS.DELIVERY' | translate"
        [title]="es.deliveryOrdersCount + '/' + es.shipmentsCount"
      >
        {{ es.deliveryOrdersCount }}/{{ es.shipmentsCount }}
      </td>
    </tr>

    <tr *ngIf="isLoading" class="scrolling-container">
      <th colspan="9">
        <loading-spinner [show]="isLoading"></loading-spinner>
      </th>
    </tr>
  </tbody>

  <tfoot>
    <tr>
      <td [colSpan]="9">
        <div class="d-flex justify-content-between align-items-center flex-wrap">
          <div class="py-2">
            <ng-template [ngIf]="totalRows">{{ "LABELS.TOTAL_ROWS" | translate }}: {{ totalRows }}/{{ total }}</ng-template>
          </div>
          <div class="py-2 mr-2 d-flex">
            <ng-select
              id="page-limit"
              class="custom"
              [items]="[20, 50, 100]"
              [clearable]="false"
              [ngModel]="limit"
              (ngModelChange)="limitChanged.emit($event)"
            ></ng-select>
            <ng-template [ngIf]="total > limit">
              <pagination-controls
                class="custom-pagination"
                [id]="tableId"
                [maxSize]="paginationMaxSize$ | async"
                [previousLabel]="'LABELS.PREVIOUS' | translate"
                [nextLabel]="'LABELS.NEXT' | translate"
                (pageChange)="onPageChange($event)"
                (pageBoundsCorrection)="onPageChange($event)"
              ></pagination-controls>
            </ng-template>
          </div>
        </div>
      </td>
    </tr>
  </tfoot>
</table>
